import React from 'react';
import constants from '../../config/constants';


const Footer = () => (
  <footer className="footer">
    <div className="container-fluid">
    Copyright © {constants.tournament} Tournament, {new Date().getFullYear()}
    </div>
  </footer>
);


export default Footer;


// WEBPACK FOOTER //
// ./src/pages/Main/Footer.js